import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import helper from '../../../utilities/helper';
import ProviderManager from '../../../provider/providerManager';
//import SalesHeader from '../../Shared/SalesHeader/SalesHeader';
import ProgressBar from '../../Shared/ProgressBar/progressBar';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import {clearStateHistoryAction} from '../../../utilities/stateHistory/stateHistorySlice';
import CreditCardAlert from '../../Shared/CreditCardAlert/CreditCardAlert';

//store functions
import {initSale, resetBlock, getSaleCatalogAsync} from './saleBlockSlice';

//pages
import WelcomePage from './Pages/WelcomePage';
import LoginPage from './Pages/LoginPage';
import ProductsPage from './Pages/ProductsPage';
import ExtraPage from './Pages/ExtraPage';
import AddressPage from './Pages/AddressPage';
import UserAddressPage from './Pages/UserAddressPage';
import TechnicianPage from './Pages/TechnicianPage';
import DeliveryAddressPage from './Pages/DeliveryAddressPage';
import EmailPage from './Pages/EmailPage';
import OtpVerifyPhonePage from './Pages/OtpVerifyPhonePage';
import OtpVerifyCodePage from './Pages/OtpVerifyCodePage';
import PersonalInfoPage from './Pages/PersonalInfoPage';
import PaymentPage from './Pages/PaymentPage';
import SummaryPage from './Pages/SummaryPage';
import SuccessPage from './Pages/SuccessPage';
import ErrorPage from './Pages/ErrorPage';
import FamilyPackageErrorPage from './FamilyPackageError/FamilyPackageErrorPage';

//cellular
import CellularPackagesPage from './Pages/CellularPackagesPage';
import ChooseNumberPage from './Pages/ChooseNumberPage';
import NewNumberPage from './Pages/NewNumberPage';
import SimActivationPage from './Pages/SimActivationPage';

//internet
import InternetPackagesPage from './Pages/InternetPackagesPage';
import FiberUpgradesPage from './Pages/FiberUpgradesPage';
import MeshUpgradePage from './Pages/MeshUpgradePage';
import BezeqFiberProductsPage from './Pages/BezeqFiberProductsPage';
import ChooseTypeSIM from './Pages/ChooseTypeSIM';

import {goToPage} from './saleBlockSlice';

import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {getOrganizationFamilyPackagesData} from '../WelcomeBlock/welcomeBlockSlice';

const Sale = (props) => {
  let currentView = null;
  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initSale({saleBlock: props.iContent});
      //props.clearStateHistoryAction();
      //props.getSaleCatalogAsync();
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

  useClearStateResetFlag();
  //--------------- useEffect ---------------

  //--------------- useEffect ---------------

  useEffect(() => {
    const getOrganizationFamilyPackagesDataAsync = async () => {
      props.showAppLoader();
      await props.getOrganizationFamilyPackagesData();
      props.hideAppLoader();
    };
    if (props.isFamilyPackage) {
      getOrganizationFamilyPackagesDataAsync();
    }
  }, []);

  useEffect(() => {
    if (props.isFamilyPackage && props.familyPackagesData && !props.familyPackagesData.isAllowed) {
      props.goToPage({page: 'familyPackageErrorPage', percent: 0});
    }
  }, [props.familyPackagesData]);

  //--------------- useEffect ---------------

  switch (props.page) {
    case 'welcomePage':
      currentView = <WelcomePage />;
      break;
    case 'loginPage':
      currentView = <LoginPage context={props.context} />;
      break;
    case 'productsPage':
      currentView = <ProductsPage />;
      break;
    case 'extraPage':
      currentView = <ExtraPage />;
      break;
    case 'addressFormPage':
      currentView = <AddressPage context={props.context} />;
      break;
    case 'userAddressPage':
      currentView = <UserAddressPage />;
      break;
    case 'technicianPage':
      currentView = <TechnicianPage />;
      break;
    case 'deliveryAddressPage':
      currentView = <DeliveryAddressPage />;
      break;
    case 'emailPage':
      currentView = <EmailPage />;
      break;
    case 'otpVerifyPhone':
      currentView = <OtpVerifyPhonePage />;
      break;
    case 'otpVerifyCode':
      currentView = <OtpVerifyCodePage />;
      break;
    case 'personalInfoPage':
      currentView = <PersonalInfoPage />;
      break;
    case 'paymentPage':
      currentView = <PaymentPage />;
      break;
    case 'summaryPage':
      currentView = <SummaryPage />;
      break;
    case 'successPage':
      currentView = <SuccessPage context={props.context} />;
      break;
    case 'errorPage':
      currentView = <ErrorPage />;
      break;

    //cellular
    case 'cellularPackagesPage':
      currentView = <CellularPackagesPage />;
      break;
    case 'chooseNumberPage':
      currentView = <ChooseNumberPage />;
      break;
    case 'newNumberPage':
      currentView = <NewNumberPage />;
      break;
    case 'simActivationPage':
      currentView = <SimActivationPage />;
      break;
    case 'chooseTypeSIM':
      currentView = <ChooseTypeSIM context={props.context} />;
      break;
    //internet
    case 'internetPackagesPage':
      currentView = <InternetPackagesPage />;
      break;
    case 'fiberUpgradesPage':
      currentView = <FiberUpgradesPage />;
      break;
    case 'meshUpgradePage':
      currentView = <MeshUpgradePage />;
      break;
    case 'bezeqFiberProductsPage':
      currentView = <BezeqFiberProductsPage />;
      break;

    case 'familyPackageErrorPage':
      currentView = <FamilyPackageErrorPage />;
      break;
  }

  return (
    <>
      <ProgressBar points={props.progressBarPoints} percent={props.percent} />
      {currentView}
      {((props.saleType != 'internet' && props.page === 'welcomePage') ||
        (props.saleType == 'internet' && props.page === 'addressFormPage')) && (
        <CreditCardAlert link={props.creditIndicatorLink} title={props.creditIndicatorTitle} />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    creditIndicatorLink: state.saleBlock.epiServer?.creditIndicatorLink,
    creditIndicatorTitle: state.saleBlock.epiServer?.creditIndicatorTitle,
    isFamilyPackage: state.saleBlock.isFamilyPackage,
    familyPackagesData: state.welcomeBlock.familyPackagesData,
  };
};

const mapDispatchToProps = {
  initSale,
  resetBlock,
  goToPage,
  getSaleCatalogAsync,
  clearStateHistoryAction,
  showAppLoader,
  hideAppLoader,
  getOrganizationFamilyPackagesData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sale);
